import React from 'react'
import './CashReloadView.scss'
import _ from 'lodash'
import {STEPS} from "../../../../constants";

import CONFIG from '../../../../config'
import {getLanguageScope, C, capitalize} from '../../../../helpers'

const _i18n = getLanguageScope('cash_reload');

import {Grid, Header, Form, Input, Radio, Table, Message, Label, Image, Icon, Button} from 'semantic-ui-react'

import {validator} from '../models/transaction'

import ScannerDevice from '../../../../components/Devices/Scanner/containers/ScannerContainer'
import Amount from '../../shared/Amounts/containers/AmountContainer'
import Navigation from '../../shared/Navigation/containers/NavigationContainer'

class CashReloadView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    const { card_track1, card_track2, resetCardOperations, updateCardData } = this.props;

    if(nextProps.card_track1 !== card_track1 || nextProps.card_track2 !== card_track2){
      resetCardOperations();
      updateCardData();
    }
  }


  renderCheckBalance() {
    const {checkBalance, check_balance_error, check_balance_response_text,
      show_balance, can_check_balance, balance_amount} = this.props;

    let balanceView = null;

    if(show_balance){
     balanceView = (
       <Table.Row>
         <Table.Cell>
           <Header as={'h4'} icon={'dollar sign'} content={`${_i18n('balance')}`}/>
         </Table.Cell>
         <Table.Cell>
           {C(balance_amount)}
         </Table.Cell>
       </Table.Row>
     )
    }

    return (
      <React.Fragment>
        {balanceView}

        {can_check_balance ?
          <Table.Row>
            <Table.Cell colSpan={'2'}>
              <Form>
                <Form.Button content={_i18n('check_balance')} onClick={() => checkBalance()} />
                <Message visible={check_balance_error} error header={check_balance_response_text}/>
              </Form>
            </Table.Cell>
          </Table.Row> : null}
      </React.Fragment>
    )

  }

  render() {
    const {title, icon, checkFields, submitTransaction, ready_to_submit, account, cardholder_name,
      changeStep, prevalins_error, prevalins_response_text } = this.props;

    return (
      <Grid columns='equal'>
        <Grid.Row divided style={{'minHeight': 250}} stretched columns={2}>
          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={title} as='h3'/>
                <Header style={{fontWeight: 400}} content={_i18n('warning')} as={'h4'}/>
                <ScannerDevice scanType={'card'}/>
              </Grid.Column>

              <Grid.Column>

                <Table className={'card-info_container'} basic='very'>
                  <Table.Body>
                    {cardholder_name ?
                      <Table.Row>
                        <Table.Cell>
                          <Header as={'h4'} icon={'address card outline'} content={`${_i18n('cardholder_name')}`}/>
                        </Table.Cell>
                        <Table.Cell>
                          {cardholder_name}
                        </Table.Cell>
                      </Table.Row>
                      : null}

                    {account ?
                      <Table.Row>
                        <Table.Cell>
                          <Header as={'h4'} icon={'credit card outline'} content={`${_i18n('account')}`}/>
                        </Table.Cell>
                        <Table.Cell>
                          {account}
                        </Table.Cell>
                      </Table.Row>
                      : null}

                    {this.renderCheckBalance()}

                  </Table.Body>
                </Table>

              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
          <Grid.Column>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Amount/>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>

        <Navigation
          onSubmit={() => submitTransaction()}
          onBackCustom={() => changeStep(STEPS.CATEGORIES)}
          showSubmit={true}
          disabledSubmit={ready_to_submit}
          submitValidator={() => checkFields(validator)}
          showError={prevalins_error}
          messageError={prevalins_response_text}
        />

      </Grid>
    )
  }
}

CashReloadView.propTypes = {};

export default CashReloadView


// WEBPACK FOOTER //
// ./src/components/Applications/CashReload/components/CashReloadView.js